import permission from './permission.config';

export const isAllowedTo = (permissionType) => {
  if (!permission[permissionType]) {
    return false;
  }
  const countryCheck = localStorage.getItem('country');
  const vehicleCheck = localStorage.getItem('vehicleType');
  const allowed = permission[permissionType].filter((vertical) => {
    return (
      countryCheck === vertical.country && vehicleCheck === vertical.vehicle
    );
  });

  return allowed.length > 0;
};

const FILE_VERSION = process.env.REACT_APP_FILE_VERSION;
